import { render } from "./select-dropdown.vue?vue&type=template&id=33d0b4a8&scoped=true&ts=true"
import script from "./select-dropdown.vue?vue&type=script&lang=ts"
export * from "./select-dropdown.vue?vue&type=script&lang=ts"

import "./select-dropdown.vue?vue&type=style&index=0&id=33d0b4a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d0b4a8"]])

export default __exports__